<template>
  <div class="mx-auto my-2">
    <v-card class="addCard mb-2 mx-4" flat>
      <v-card-title>
        <v-spacer></v-spacer>

        <v-btn
            v-if="canCreateGraduateTrack"
            class="teal white--text"
            depressed
            @click="AddGraduateTrack()"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Create new</span>
        </v-btn>
      </v-card-title>
    </v-card>

    <v-card class="mx-4" flat>
      <v-card-title>
        Graduate Tracks
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel
              :data="graduateTracks"
              :fields="export_fields"
              name="GraduateTracks.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary" dark depressed small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="graduateTracks"
          :loading="loading"
          :search="search"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.training_center.trainingCenterName`]="{ item }">
          <label for="item">{{
            item.training_center ? item.training_center.trainingCenterName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.health_profession.name`]="{ item }">
          <label for="item">{{
            item.health_profession ? item.health_profession.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.femaleCount`]="{ item }">
          <label for="item">{{
            item.femaleCount ? item.femaleCount : "-"
            }}</label>
        </template>
        <template v-slot:[`item.maleCount`]="{ item }">
          <label for="item">{{
            item.maleCount ? item.maleCount : "-"
            }}</label>
        </template>
        <template v-slot:[`item.totalCount`]="{ item }">
          <label for="item">{{
            item.totalCount ? item.totalCount : "-"
            }}</label>
        </template>
        <template v-if="canEditGraduateTrack" v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editGraduateTrack(item)"
                  v-on="on"
              >mdi-pencil
              </v-icon
              >
            </template>
            <span>Edit Graduate Track</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  style="color:red;"
                  @click="deleteGraduateTrack(item)"
                >mdi-delete</v-icon>
              </template>
              <span>Delete Graduate Track</span>
            </v-tooltip>
          </template>-->
      </v-data-table>
    </v-card>
    <template>
      <v-dialog v-model="dialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdAddGraduateTrack
              v-if="dialog"
              :graduate-track="graduateTrack"
              @close="dialog = false"
              @registerOrUpdateGraduateTrack="registerOrUpdateGraduateTrack"
          ></HrdAddGraduateTrack>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import {GraduateTrackingService} from "./graduate_tracks.service";
import HrdAddGraduateTrack from "./hrd-add-graduate-track";
import {getUser} from "@/utils/helper";

export default {
  components: {
    HrdAddGraduateTrack,
  },
  data() {
    return {
      headers: [
        {text: "CPD Provider", value: "training_center.trainingCenterName"},
        {text: "Health Profession", value: "health_profession.name"},
        {
          text: "Female",
          value: "femaleCount",
          sortable: false,
          align: "center",
        },
        {text: "Male", value: "maleCount", sortable: false, align: "center"},
        {
          text: "Total Count",
          value: "totalCount",
          sortable: false,
          align: "center",
        },
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      export_fields: {
        "CPD Provider": "training_center.name",
        "Health Profession": "health_profession.name",
        "Staff Type": "staff_type.name",
        "Graduate Year": "graduateYear",
        "Male Count": "maleCount",
        "Female Count": "femaleCount",
        "Total Count": "totalCount",
      },
      graduateTracks: [],
      graduateTrack: null,
      title: "",
      search: "",
      loading: false,
      dialog: false,
    };
  },
  async beforeMount() {
    this.fetchGraduateTracks();
  },
  computed: {
    canCreateGraduateTrack() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Monitoring" && permission.canCreate
      );
    },
    canEditGraduateTrack() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Monitoring" && permission.canUpdate
      );
    },
    canViewProgram() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Monitoring" && permission.canRead
      );
    },
  },
  methods: {
    async fetchGraduateTracks() {
      this.loading = true;
      const res = await GraduateTrackingService.getGraduateTracks();
      if (res.status === 200) {
        this.loading = false;
        this.graduateTracks = res.data;
      } else {
        this.loading = false;
        this.$toast.error("Error fetching gradaute tracks");
      }
    },

    editGraduateTrack(item) {
      this.graduateTrack = item;
      this.title = "Edit Graduate Track";
      this.dialog = true;
    },
    AddGraduateTrack() {
      this.graduateTrack = null;
      this.title = "Add Graduate Track";
      this.dialog = true;
    },
    async deleteGraduateTrack(item) {
      let res = null;
      res = await GraduateTrackingService.delete(item.id, item);
      if (res.status === 200) {
        this.$toast.success(res.data.message);
        this.fetchGraduateTracks();
      } else {
        this.$toast.error("Unable to delete graduate track, please try again!");
      }
    },
    async registerOrUpdateGraduateTrack(graduateTrack) {
      let res = null;

      if (this.graduateTrack !== null) {
        res = await GraduateTrackingService.update(
            graduateTrack.id,
            graduateTrack
        );
      } else {
        res = await GraduateTrackingService.create(graduateTrack);
      }

      if (res.status === 200) {
        this.$toast.success(res.data.message);
        this.fetchGraduateTracks();
      } else {
        this.$toast.error("Unable to create graduate track, please try again!");
      }
    },
  },
};
</script>
<style scoped>
.addCard {
  background: hsla(0, 0%, 100%, 0.45);
}
</style>
